import React from "react";
import { Layout, Row, Col } from "antd";
import styled from "styled-components";

const CustomLayout = styled(Layout)`
  && {
    min-height: 100vh;
    width: 100vw;
    background: rgb(0, 69, 124);
  }
`;

const CustomRow = styled(Row)`
  && {
    background: #fff;
    width: 80%;
    border-radius: 15px;
    margin: 25px auto;

    @media (min-width: 768px) {
      width: 75%;
    }

    @media (min-width: 992px) {
      width: 65%;
    }

    @media (min-width: 1200px) {
      width: 50%;
    }
  }
`;

const CustomCol = styled(Col)`
  && {
    padding: 15px;
    box-shadow: rgba(0, 0, 0, 0.8) 0 20px 60px -10px;

    @media (min-width: 768px) {
      padding: 25px;
    }

    @media (min-width: 992px) {
      padding: 50px;
    }
  }
`;

const Logo = styled.img`
  display: block;
  margin: 0 auto;
  width: 90%;

  @media (min-width: 768px) {
    width: auto;
  }
`;

const BasicLayout = props => {
  return (
    <CustomLayout>
      <CustomRow type="flex" justify="center">
        <CustomCol span={24}>
          <Logo src="/assets/img/hcdelogo.png" id="logo" />
          {props.children}
        </CustomCol>
      </CustomRow>
    </CustomLayout>
  );
};

export default BasicLayout;
